module.exports = __webpack_public_path__ + "static/media/domikloading.5b9eb1c2.gif";